module.exports = __webpack_public_path__ + "static/media/photo_building.9cd07fca.jpg";